// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sl-create-modal {
  max-width: 480px;
}

.sl-address-field {
  display: flex;
  flex-direction: column;
  margin: 16px 0;
}

.sl-address-field label {
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 14px;
}

.sl-address-field select {
  width: 100%;
  height: 36px;
  border: none;
  border-radius: 5px;
  padding: 0 8px;
  font-size: 14px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.sl-address-field select:focus {
  outline: none;
}

.sl-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.sl-btn {
  display: inline-block;
  flex: 0 0 auto;
  padding: 6px 16px;
  font-size: 13px;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  line-height: 1.4;
}

.sl-btn-cancel {
  background-color: #6c757d;
}

.sl-btn-cancel:hover {
  background-color: #5a6268;
}

.sl-btn-primary {
  background-color: #1d0f40;
}

.sl-btn-primary:hover {
  background-color: #271456;
}

.sl-btn-primary:disabled {
  background-color: #9e9e9e;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/create/shipping-label/shipping-label.create.modal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".sl-create-modal {\n  max-width: 480px;\n}\n\n.sl-address-field {\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0;\n}\n\n.sl-address-field label {\n  font-weight: bold;\n  margin-bottom: 6px;\n  font-size: 14px;\n}\n\n.sl-address-field select {\n  width: 100%;\n  height: 36px;\n  border: none;\n  border-radius: 5px;\n  padding: 0 8px;\n  font-size: 14px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.sl-address-field select:focus {\n  outline: none;\n}\n\n.sl-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.sl-btn {\n  display: inline-block;\n  flex: 0 0 auto;\n  padding: 6px 16px;\n  font-size: 13px;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: white;\n  line-height: 1.4;\n}\n\n.sl-btn-cancel {\n  background-color: #6c757d;\n}\n\n.sl-btn-cancel:hover {\n  background-color: #5a6268;\n}\n\n.sl-btn-primary {\n  background-color: #1d0f40;\n}\n\n.sl-btn-primary:hover {\n  background-color: #271456;\n}\n\n.sl-btn-primary:disabled {\n  background-color: #9e9e9e;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
